/**
 * Build linkedFlights-shaped slice from two LDS OneWay flight deals (dynamic package self-compose).
 */

function flightNodesFromDeal(deal) {
  const lf = deal?.linkedFlights;
  if (!lf) return [];
  const f = lf.flight;
  if (f == null) return [];
  return Array.isArray(f) ? f : [f];
}

/** First leg object from a OneWay LDS deal (for selectedDepart / selectedReturn). */
export function firstLegFromLdsDeal(deal) {
  const node = flightNodesFromDeal(deal)[0];
  if (!node?.leg) return null;
  const L = node.leg;
  return Array.isArray(L) ? L[0] : L;
}

/**
 * @returns {{ flight: unknown[] } | null}
 */
export function mergeOwDealsToLinkedFlightsSlice(outboundDeal, inboundDeal) {
  const o = flightNodesFromDeal(outboundDeal)[0];
  const i = inboundDeal ? flightNodesFromDeal(inboundDeal)[0] : null;
  if (o && i) return { flight: [o, i] };
  if (o) return { flight: [o] };
  return null;
}
